$(function () {
  $('[data-behaviour~=privacy-cookie-close]').click(function (e) {
    e.preventDefault()
    $(e.target).closest('.privacy-cookie').slideUp()
    $('#subheader').css({'top': '38px'})
    $.ajax({
        url: '/'
      , type: 'post'
      , data: {'cookie': 1}
    })
  })
  $('[data-behaviour~=privacy-cookie-modal]').click(function (e) {
    e.preventDefault()
    $('#privacy-cookie-modal').modal()
  })
})
